import { ErrorMessage, Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { Alert, Breadcrumb, Button, Col, Container, Form, FormCheck, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { LoadingSpinner } from "../../components/LoadingSpinner";
import { IContactFull } from "../../customTypings/ContactFull";
import { IDeliveryOrInstallationForm } from "../../customTypings/DeliveryOrInstallationForm";
import {
    customerService, emailTemplateService, formService,
    orderService, taskService, userService
} from "../../services";
import { ReactSelectBootstrapStyle } from "../../styles/ReactSelectBootstrapStyle";
import getCustomerEmail from "./Customer";
import mapEmailBody from "./Mapping";
function DeliveryOrInstallationForm() {

    const [alertVariant, setAlertVariant] = useState("danger");

    const [allCustomers, setAllCustomers] = useState<any[]>();
    const [selectedCustomerId, setSelectedCustomerId] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState<any>({});

    const [allUsers, setAllUsers] = useState<any[]>();

    const [allTasks, setAllTasks] = useState<any[]>();
    const [allSelectableTasks, setAllSelectableTasks] = useState<any[]>();
    const [allCustomerTasks, setAllCustomerTasks] = useState<any[]>();
    const [selectedTaskId, setSelectedTaskId] = useState("");
    const [selectedTask, setSelectedTask] = useState<any>({});

    const [allProducts, setAllProducts] = useState<any[]>();
    const [customerProducts, setCustomerProducts] = useState<any[]>();
    const [allCustomerProducts, setAllCustomerProducts] = useState<any[]>();
    const [selectedProductId, setSelectedProductId] = useState("");
    const [selectedProduct, setSelectedProduct] = useState<any>({});

    const [customerContacts, setCustomerContacts] = useState<any[]>();
    const [allCustomerContacts, setAllCustomerContacts] = useState<IContactFull[]>();
    const [selectedContactId, setSelectedContactId] = useState("");
    const [selectedContact, setSelectedContact] = useState<any>({});

    const [emailTemplate, setEmailTemplate] = useState<any>({});

    useEffect(() => {
        Promise.all([orderService.getAll(), customerService.getAllListItems(), userService.getAllListItems(), taskService.getAll(), taskService.getAllListItems()]).then((response) => {
            setAllProducts(response[0]);
            setAllCustomers(response[1]);
            setAllUsers(response[2]);
            setAllTasks(response[3]);
            setAllSelectableTasks(response[4]);
        });
    }, []);

    useEffect(() => {
        getCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCustomerId]);

    useEffect(() => {
        if (selectedCustomer && selectedCustomerId) {
            customerService.getAllContacts(selectedCustomerId).then((fullcustomerContacts) => {
                setAllCustomerContacts(fullcustomerContacts);
                setSelectedContactId(fullcustomerContacts.find((contact: any) => contact.isPrimaryContact)?.id);
                const contacts = fullcustomerContacts.map((item: any) => ({
                    label: `${item.name} (${item.emailAddress})`,
                    value: item.id
                }));
                setCustomerContacts(contacts);
                if (allProducts) {
                    const products = allProducts.filter(item => item.customerId === selectedCustomerId);
                    setCustomerProducts(products);
                    const selectableProducts = products.map((item: any) => ({
                        label: `${item.brand} ${item.model} ${item.color}`,
                        value: item.id
                    }));
                    setAllCustomerProducts(selectableProducts);
                }
                if (allTasks && allSelectableTasks) {
                    const filteredArray = allSelectableTasks.filter((item2) =>
                        allTasks.some((item1) => item1.id === item2.value && item1.customerId === selectedCustomerId)
                    );
                    setAllCustomerTasks(filteredArray)
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCustomer]);

    useEffect(() => {
        getTask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTaskId]);

    useEffect(() => {
        getContact();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContactId]);

    useEffect(() => {
        getProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProductId]);

    useEffect(() => {
        emailTemplateService.getAll().then((response) => {
            const deliveryOrInstallationFormForSigningTemplate = response.find((template: any) => template.name === "Delivery/Installation Form for Signing");
            if (deliveryOrInstallationFormForSigningTemplate) {
                setEmailTemplate(deliveryOrInstallationFormForSigningTemplate);
            } else {
                console.error("Delivery/Installation template for Signing not found");
            }
        });
    }, []);

    function getCustomer() {
        if (selectedCustomerId) {
            customerService.getFull(selectedCustomerId).then((customer) => {
                setSelectedCustomer(customer);
            });
        }
    }
    function getTask() {
        if (selectedTaskId) {
            taskService.get(selectedTaskId).then((task) => {
                setSelectedTask(task);
            });
        }
    }
    function getContact() {
        if (selectedContactId && allCustomerContacts) {
            setSelectedContact(allCustomerContacts.find(item => item.id === selectedContactId));
        };
    }
    function getProduct() {
        if (selectedProductId && customerProducts) {
            setSelectedProduct(customerProducts.find(item => item.id === selectedProductId));
        };
    }

    const address = selectedContact.address;
    const emailBody = emailTemplate.body;
    const navigate = useNavigate();

    const initialValues: any = {
        id: "",
        taskId: "",
        customerName: "",
        customerContactName: "",
        customerContactTitle: "",
        customerAddress: address ? `${address?.line1}, ${address?.line2}, ${address?.line3}, ${address?.town}, ${address?.county}, ${address?.postcode}` : "",
        customerHomeTel: "",
        customerMobileTel: "",
        customerWorkTel: "",
        customerOtherTel: "",
        customerEmail: selectedContact ? selectedContact?.emailAddress : "",
        accessNotes: "",
        productMake: "",
        productModel: "",
        productColour: "",
        productCabinet: "",
        productSerialNumber: "",
        productCondition: "",
        productComments: "",
        orderNumber: "",
        salesPersonName: "",
        balance: "",
        paymentMethod: "",
        dateBalancePaid: "",
        financeAgreementName: "",
        servicePlanHPWOCare: false,
        servicePlanHPWSilk: false,
        servicePlanNoPumpOSB: false,
        servicePlanLC: false,
        servicePlanLCLite: false,
        servicePlanLPC: false,
        servicePlanGold: false,
        servicePlanUltimate: false,
        servicePlanEPWellness: false,
        servicePlanEPWellnessPlus: false,
        engineerNameList: "",
        engineerDate: null,
        accessClear: false,
        accessComments: "",
        visitComments: "",
        name: "",
        sentTime: null,
        completedTime: null,
    };

    const save = async (
        values: any,
        setStatus: any,
        setSubmitting: any,
        setFieldError: any,
        resetForm: any
    ) => {
        const updatedDeliveryOrInstallationForm: IDeliveryOrInstallationForm = {
            id: undefined,
            taskId: values.taskId,
            signingURL: undefined,
            taskName: selectedTask.name,
            taskURL: undefined,
            customerName: selectedCustomer.name,
            customerContactName: selectedContact.name,
            customerContactTitle: values.customerContactTitle,
            customerAddress: values.customerAddress,
            customerHomeTel: values.customerHomeTel,
            customerMobileTel: values.customerMobileTel,
            customerWorkTel: values.customerWorkTel,
            customerOtherTel: values.customerOtherTel,
            customerEmail: values.customerEmail,
            accessNotes: values.accessNotes,
            productMake: selectedProduct.make,
            productModel: selectedProduct.model,
            productColour: selectedProduct.color,
            productCabinet: selectedProduct.cabinet,
            productSerialNumber: selectedProduct.serialNumber,
            productCondition: selectedProduct.productCondition,
            productComments: values.productComments,
            orderNumber: values.orderNumber,
            salesPersonName: values.salesPersonName,
            balance: values.balance,
            paymentMethod: values.paymentMethod,
            dateBalancePaid: values.dateBalancePaid,
            financeAgreementName: values.financeAgreementName,
            servicePlanHPWOCare: values.servicePlanHPWOCare,
            servicePlanHPWSilk: values.servicePlanHPWSilk,
            servicePlanNoPumpOSB: values.servicePlanNoPumpOSB,
            servicePlanLC: values.servicePlanLC,
            servicePlanLCLite: values.servicePlanLCLite,
            servicePlanLPC: values.servicePlanLPC,
            servicePlanGold: values.servicePlanGold,
            servicePlanUltimate: values.servicePlanUltimate,
            servicePlanEPWellness: values.servicePlanEPWellness,
            servicePlanEPWellnessPlus: values.servicePlanEPWellnessPlus,
            engineerNameList: values.engineerNameList,
            engineerDate: values.engineerDate,
            accessClear: values.accessClear,
            accessComments: values.accessComments,
            visitComments: values.visitComments,
            name: "Delivery/Installation Form",
            sentTime: new Date(),
            completedTime: undefined,
        };
        formService.addDeliveryOrInstallationForm(updatedDeliveryOrInstallationForm).then(
            async (response) => {
                setSubmitting(false);
                if (response.status === "Success") {
                    resetForm({ values: "" });
                    setAlertVariant("success");
                    setStatus("Delivery/Installation Form has been submitted successfully, You will receive a confirmational email shortly");
                    const updatedBody = await mapEmailBody({ body: emailBody, id: response.id });
                    const receiverEmail = await getCustomerEmail({ id: response.id });
                    emailTemplateService.sendAutoEmail(emailTemplate.subject, updatedBody, [receiverEmail]).then(
                        (response) => {
                            setStatus(response.message);
                        });
                    setTimeout(() => {
                        navigate("/formListPage");
                    }, 2000);
                } else {
                    setAlertVariant("danger");
                    setStatus(response.message);
                }
            },
            (error) => {
                setAlertVariant("danger");
                setStatus(error.title);
            }
        );
    };
    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Helmet>
                            <title>Delivery/Installation Form</title>
                        </Helmet>

                        <Breadcrumb>
                            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/formListPage" }}>
                                Forms
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Delivery/Installation Form</Breadcrumb.Item>
                        </Breadcrumb>

                        <h1 className="my-3">Delivery/Installation Form</h1>
                        <Formik
                            initialValues={{ ...initialValues }}
                            enableReinitialize
                            onSubmit={(
                                values,
                                { setStatus, setSubmitting, setFieldError, resetForm }
                            ) => {
                                save(values, setStatus, setSubmitting, setFieldError, resetForm);
                            }}
                        >
                            {({
                                errors,
                                status,
                                touched,
                                isSubmitting,
                                handleSubmit,
                                values,
                                setStatus,
                                handleChange,
                                setFieldValue,
                            }) => (
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group as={Row} className="mb-3" controlId="customerName">
                                        <Form.Label column sm={3}>
                                            Name of the customer <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setSelectedCustomerId(value.value);
                                                    setFieldValue("customerName", value == null ? "" : value.label);
                                                }}
                                                required
                                                options={allCustomers}
                                            />
                                            <ErrorMessage name="customerName" component="div" className="invalid-feedback" />

                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="taskId">
                                        <Form.Label column sm={3}>
                                            Associated Task <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setSelectedTaskId(value.value);
                                                    setFieldValue("taskId", value == null ? "" : value.value);
                                                }}
                                                required
                                                options={allCustomerTasks}
                                            />
                                            <ErrorMessage name="taskId" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="customerContactName">
                                        <Form.Label column sm={3}>
                                            Name of the main customer contact <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setSelectedContactId(value.value);
                                                    setFieldValue("customerContactName", value == null ? "" : value.label);
                                                }}
                                                isClearable
                                                options={customerContacts}
                                                value={customerContacts?.find(contact => contact.value === selectedContactId)}
                                            />
                                            <ErrorMessage name="customerContactName" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="customerContactTitle">
                                        <Form.Label column sm={3}>
                                            Title of the main customer contact
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerContactTitle" type="text" className={"form-control" + (errors.customerContactTitle && touched.customerContactTitle ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerContactTitle" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerAddress">
                                        <Form.Label column sm={3}>
                                            Inline address summary
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerAddress" type="text" className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerAddress" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerHomeTel">
                                        <Form.Label column sm={3}>
                                            Home telephone
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerHomeTel" type="text" className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerHomeTel" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerMobileTel">
                                        <Form.Label column sm={3}>
                                            Mobile telephone
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerMobileTel" type="text" className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerMobileTel" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerWorkTel">
                                        <Form.Label column sm={3}>
                                            Work telephone
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerWorkTel" type="text" className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerWorkTel" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerOtherTel">
                                        <Form.Label column sm={3}>
                                            Other telephone
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerOtherTel" type="text" className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerOtherTel" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="customerEmail">
                                        <Form.Label column sm={3}>
                                            Email Address
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="customerEmail" type="text" required className={"form-control" + (errors.customerAddress && touched.customerAddress ? " is-invalid" : "")} />
                                            <ErrorMessage name="customerEmail" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="accessNotes">
                                        <Form.Label column sm={3}>
                                            Notes about accessing the customer site
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control as="textarea" name="accessNotes"
                                                onChange={handleChange}
                                                className={"form-control" + (errors.accessNotes && touched.accessNotes ? " is-invalid" : "")} />
                                            <ErrorMessage name="accessNotes" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="product">
                                        <Form.Label column sm={3}>
                                            Customer Product
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setSelectedProductId(value.value);
                                                    setFieldValue("product", value == null ? "" : value.label);
                                                }}
                                                isClearable
                                                options={allCustomerProducts}
                                            />
                                            <ErrorMessage name="product" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="productComments">
                                        <Form.Label column sm={3}>
                                            Comments about the product
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control as="textarea" name="productComments"
                                                onChange={handleChange}
                                                className={"form-control" + (errors.productComments && touched.productComments ? " is-invalid" : "")} />
                                            <ErrorMessage name="productComments" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="orderNumber">
                                        <Form.Label column sm={3}>
                                            Order number for the product sale
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="orderNumber" type="text" className={"form-control" + (errors.orderNumber && touched.orderNumber ? " is-invalid" : "")} />
                                            <ErrorMessage name="orderNumber" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="salesPersonName">
                                        <Form.Label column sm={3}>
                                            Name of sales person
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="salesPersonName" type="text" className={"form-control" + (errors.salesPersonName && touched.salesPersonName ? " is-invalid" : "")} />
                                            <ErrorMessage name="salesPersonName" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="balance">
                                        <Form.Label column sm={3}>
                                            Amount paid/to pay <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="balance" placeholder="£" type="text" className={"form-control" + (errors.balance && touched.balance ? " is-invalid" : "")} />
                                            <ErrorMessage name="balance" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="paymentMethod">
                                        <Form.Label column sm={3}>
                                            Payment method
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setFieldValue("paymentMethod", value === null ? "" : value.value);
                                                }}
                                                isClearable
                                                options={['cash', 'cheque', 'card'].map((method) => ({ label: method, value: method }))}
                                            />
                                            <ErrorMessage name="paymentMethod" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="dateBalancePaid">
                                        <Form.Label column sm={3}>
                                            Date paid <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Field name="dateBalancePaid" type="datetime-local" className={"form-control" + (errors.dateBalancePaid && touched.dateBalancePaid ? " is-invalid" : "")} />
                                            <ErrorMessage name="dateBalancePaid" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="financeAgreementName">
                                        <Form.Label column sm={3}>
                                            Name on finance agreement (if required)
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="financeAgreementName" type="text" className={"form-control" + (errors.financeAgreementName && touched.financeAgreementName ? " is-invalid" : "")} />
                                            <ErrorMessage name="financeAgreementName" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <div className="row">
                                        {['HPWOCare', 'HPWSilk', 'NoPumpOSB', 'LC', 'LCLite', 'LPC', 'Gold', 'Ultimate', 'EPWellness', 'EPWellnessPlus'].map((index) => (
                                            <Form.Group className="col-4 d-flex justify-content-start align-items-center gap-2" controlId={`servicePlan${index}`} key={`servicePlan${index}`}>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    label=""
                                                    checked={values[`servicePlan${index}`]}
                                                    onChange={handleChange}
                                                    name={`servicePlan${index}`}
                                                />
                                                <Form.Label>
                                                    ServicePlan{index}
                                                </Form.Label>
                                            </Form.Group>
                                        ))}
                                    </div>
                                    {/*Need to add somwthing here*/}
                                    <Form.Group as={Row} className="mb-3" controlId="engineerNameList">
                                        <Form.Label column sm={3}>
                                            Inline CSV list of engineer names
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Select
                                                styles={ReactSelectBootstrapStyle}
                                                className="stateManagedSelect"
                                                onChange={(value) => {
                                                    setFieldValue("engineerNameList", value == null ? "" : value.label);
                                                }}
                                                isClearable
                                                options={allUsers}
                                            />
                                            <ErrorMessage name="engineerNameList" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="engineerDate">
                                        <Form.Label column sm={3}>
                                            Date completed by engineer
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Field name="engineerDate" type="datetime-local" className={"form-control" + (errors.engineerDate && touched.engineerDate ? " is-invalid" : "")} />
                                            <ErrorMessage name="engineerDate" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="accessClear">
                                        <Form.Label column sm={3}>
                                            Clear Access?
                                        </Form.Label>
                                        <Col sm={9}>
                                            <FormCheck
                                                type="switch"
                                                id="custom-switch"
                                                label=""
                                                checked={values.accessClear}
                                                onChange={handleChange}
                                                name="accessClear"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="accessComments">
                                        <Form.Label column sm={3}>
                                            Comments about access
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control as="textarea" name="accessComments"
                                                onChange={handleChange}
                                                className={"form-control" + (errors.accessComments && touched.accessComments ? " is-invalid" : "")} />
                                            <ErrorMessage name="accessComments" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="visitComments">
                                        <Form.Label column sm={3}>
                                            Comments about delivery/Installation
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control as="textarea" name="visitComments"
                                                onChange={handleChange}
                                                className={"form-control" + (errors.visitComments && touched.visitComments ? " is-invalid" : "")} />
                                            <ErrorMessage name="visitComments" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        disabled={isSubmitting}
                                        type="submit"
                                        className="me-2 d-flex align-items-end ms-auto"
                                    >
                                        {isSubmitting ? <LoadingSpinner text="Saving..." /> : "Complete"}
                                    </Button>

                                    {status && (
                                        <Alert variant={alertVariant} className="mt-3">
                                            {status}
                                        </Alert>
                                    )}
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default DeliveryOrInstallationForm;